import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCerEow, createCerEow, updateCerEow, type CerEow } from '../../api/settings';
import SettingsCrudSection, { type FieldDef } from './SettingsCrudSection';

export default function CerEowSettings() {
  const { t } = useTranslation();
  const [items, setItems] = useState<CerEow[]>([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(() => {
    void (async () => {
      setLoading(true);
      try { setItems(await getCerEow(false)); } finally { setLoading(false); }
    })();
  }, []);
  useEffect(() => { reload(); }, [reload]);

  const fields: FieldDef[] = [
    { key: 'cer', label: t('settings.cer_fields.cer'), kind: 'cer', required: true, placeholder: t('settings.cer_eow.cer_placeholder') },
    { key: 'nome_descrittivo', label: t('settings.cer_fields.descrizione'), kind: 'text', placeholder: t('settings.cer_eow.descr_placeholder') },
  ];

  return (
    <SettingsCrudSection<CerEow>
      description={t('settings.cer_eow.descrizione')}
      fields={fields}
      rows={items}
      loading={loading}
      reload={reload}
      testidPrefix="cer-eow"
      entityLabel={t('settings.cer_eow.entita')}
      emptyMsg={t('settings.cer_comune.nessun_cer')}
      onCreate={async (v) => { await createCerEow({ cer: v.cer.trim(), nome_descrittivo: v.nome_descrittivo.trim() || null }); }}
      onUpdate={async (id, v) => { await updateCerEow(id, { cer: v.cer.trim(), nome_descrittivo: v.nome_descrittivo.trim() || null }); }}
      onToggle={async (it) => { await updateCerEow(it.id, { attivo: !it.attivo }); }}
    />
  );
}
